import { useLazyQuery } from "@apollo/client/react";
import { useCallback } from "react";

import { IntentResource } from "types/generated";

import { INTENT_MODULE_RESOURCES } from "./gql";

type IntentModuleResourcesResult = {
  resources: IntentResource[];
  hasMore: boolean;
  endCursor?: string;
};

const useIntentModuleResources = (intentProjectId: string) => {
  const [fetchModuleResourcesQuery, { loading }] = useLazyQuery(INTENT_MODULE_RESOURCES, {
    fetchPolicy: "network-only",
  });

  const fetchModuleResources = useCallback(
    async (
      resourceID: string,
      first: number,
      after?: string
    ): Promise<IntentModuleResourcesResult | undefined> => {
      const { data } = await fetchModuleResourcesQuery({
        variables: { intentProjectID: intentProjectId, resourceID, first, after: after ?? null },
      });

      const result = data?.intentModuleResources;

      if (!result) {
        return undefined;
      }

      return {
        resources: result.edges.map((edge) => edge.node),
        hasMore: result.pageInfo.hasNextPage,
        endCursor: result.pageInfo.endCursor,
      };
    },
    [fetchModuleResourcesQuery, intentProjectId]
  );

  return { fetchModuleResources, loading };
};

export default useIntentModuleResources;
